export function normalizeApiBase(value: string | undefined, fallback: string): string {
  const base = (value || fallback).trim();
  return base.endsWith("/") ? base.slice(0, -1) : base;
}

export function formatApiError(body: unknown, status: number): string {
  const detail = (body as { detail?: unknown } | undefined)?.detail;

  if (typeof detail === "string") return detail;

  if (Array.isArray(detail)) {
    const parts = detail
      .map((item) => {
        if (typeof item === "string") return item;
        if (item && typeof item === "object" && "msg" in item) {
          const msg = (item as { msg?: unknown }).msg;
          const loc = (item as { loc?: unknown[] }).loc;
          const field = Array.isArray(loc) && loc.length > 1 ? loc.slice(1).join(".") : null;
          return field ? `${field}: ${String(msg)}` : String(msg);
        }
        return null;
      })
      .filter(Boolean);

    if (parts.length) return parts.join("; ");
  }

  return `HTTP ${status}`;
}
